import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Drawer, ItineraryButton, PopupHeader, Toolbar, ToolbarButton } from "@pcln/horizon";
function ItineraryBar({ title, data1, data2, drawerTitle, drawerCloseLabel = 'Close', onBackButtonClick, backButtonLabel, open, onOpenChange, children }) {
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(Toolbar, {
                buttonLeft: onBackButtonClick && /*#__PURE__*/ jsx(ToolbarButton, {
                    icon: "arrow_back",
                    label: backButtonLabel,
                    onClick: onBackButtonClick
                }),
                itineraryButton: /*#__PURE__*/ jsx(ItineraryButton, {
                    title: title,
                    data1: data1,
                    data2: data2,
                    onClick: ()=>onOpenChange(true)
                })
            }),
            /*#__PURE__*/ jsx(Drawer.Root, {
                open: open,
                onOpenChange: onOpenChange,
                snapPoints: [
                    1
                ],
                modal: true,
                children: /*#__PURE__*/ jsxs(Drawer.Portal, {
                    keepMounted: true,
                    children: [
                        /*#__PURE__*/ jsx(Drawer.Backdrop, {}),
                        /*#__PURE__*/ jsx(Drawer.Viewport, {
                            children: /*#__PURE__*/ jsxs(Drawer.Popup, {
                                height: "full",
                                children: [
                                    /*#__PURE__*/ jsx(Drawer.Handle, {}),
                                    /*#__PURE__*/ jsxs(PopupHeader.Root, {
                                        children: [
                                            /*#__PURE__*/ jsx(PopupHeader.Content, {
                                                children: /*#__PURE__*/ jsx(PopupHeader.Title, {
                                                    asTitle: Drawer.Title,
                                                    children: drawerTitle
                                                })
                                            }),
                                            /*#__PURE__*/ jsx(Drawer.Close, {
                                                render: /*#__PURE__*/ jsx(PopupHeader.Close, {
                                                    "aria-label": drawerCloseLabel
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ jsx(Drawer.Body, {
                                        children: children
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
export { ItineraryBar };
